import { defineMessages } from "react-intl"

export default defineMessages({
  addCard: {
    defaultMessage: "Add Card",
    id: "src.components.PaymentMethod.addCard",
  },
  addPaymentMethod: {
    defaultMessage: "Add Payment Method",
    id: "src.components.PaymentMethod.addPaymentMethod",
  },
  endingIn: {
    defaultMessage: "Ending In ",
    id: "src.components.PaymentMethod.endingIn",
  },
  paymentMethodAdded: {
    defaultMessage: "Payment Method added",
    id: "src.components.PaymentMethod.paymentMethodAdded",
  },
  next: {
    defaultMessage: "Next",
    id: "src.components.PaymentMethod.next",
  },
  somethingWentWrong: {
    defaultMessage: "Something went wrong.",
    id: "src.components.PaymentMethod.somethingWentWrong",
  },
  submit: {
    defaultMessage: "Submit",
    id: "src.components.PaymentMethod.submit",
  },
})
